<div class="container">
  <div class="wrapper">
    <div class="body">
      <div class="subject">
        <span class="company-name" (click)="companyClick($event)"
          >{{ companyName }}
        </span>
        has sent a request for you to update your
        <span style="font-weight: bold">{{
          certificationUpdateRequest.vendorCertificationName
        }}</span>
        certification
      </div>

      <div class="actions">
        <ng-container>
          <s-button
            type="secondary"
            skin="red"
            size="small"
            icon="pi pi-times-circle"
            iconPos="left"
            [label]="'Decline'"
            (click)="decline()"
          ></s-button>
          <s-button
            type="primary"
            skin="green"
            size="small"
            iconPos="left"
            [label]="'Update Profile'"
            [icon]="
              isButtonDisabled ? 'pi pi-spin pi-spinner' : 'pi pi-check-circle'
            "
            [disabled]="isButtonDisabled"
            (click)="accept()"
          ></s-button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog
  styleClass="delete-dialog"
  [baseZIndex]="10000"
  [closable]="true"
></p-confirmDialog>
